module.exports = __webpack_public_path__ + "img/google-petra-03.af3bb8cf.jpg";